import { ReactNode, useState, useEffect } from "react";
import DashboardNavbar from "../components/common/DashboardNavbar";
import Sidebar from "../components/common/Sidebar";
import { useLocation } from "react-router-dom";
 
interface DashboardLayoutProps {
  children: React.ReactNode;
  menuItems?: Array<{ title: string; to: string; icon: ReactNode; end?: boolean }>;
}

export default function DashboardLayout({ children, menuItems }: DashboardLayoutProps) {
  const [collapsed, setCollapsed] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  return (
    <div style={{ display: 'flex', flexDirection: 'column', height: '100vh' }} className="bg-[#F7F9FC]">
      
      {/* NAVBAR - Fixed at top, full width */}
      <div className="sticky top-0 left-0 right-0 h-[62px] z-30 bg-[#EBF0FF] border-b border-[#E0E4F0] shadow-sm flex-shrink-0">
        <DashboardNavbar onMenuToggle={() => setMobileMenuOpen(!mobileMenuOpen)} />
      </div>

      {/* MAIN FLEX LAYOUT - Sidebar + Content */}
      <div style={{ display: 'flex', flex: 1, minWidth: 0, minHeight: 0, overflow: 'hidden' }}>
        
        {/* DESKTOP SIDEBAR - Flex item on md+, fixed width */}
        <aside className="hidden md:flex md:flex-col md:flex-shrink-0 md:border-r md:border-[#E0E4F0] md:bg-[#EBF0FF] md:overflow-hidden transition-all duration-300 ease-in-out"
          style={{ width: collapsed ? '80px' : '230px', minHeight: 0, minWidth: 0 }}>
          <Sidebar menuItems={menuItems} collapsed={collapsed} onToggle={() => setCollapsed((c) => !c)} />
        </aside>

        {/* Mobile overlay when menu is open */}
        {mobileMenuOpen && (
          <div
            className="fixed inset-0 bg-black/40 backdrop-blur-sm md:hidden z-40"
            onClick={() => setMobileMenuOpen(false)}
            style={{ top: '62px', height: 'calc(100vh - 62px)' }}
          />
        )}

        {/* Mobile sidebar - shown as overlay only */}
        {mobileMenuOpen && (
          <div className="fixed left-0 top-[62px] w-[230px] z-50 md:hidden bg-[#EBF0FF] border-r border-[#E0E4F0] overflow-y-auto overflow-x-hidden" style={{ height: 'calc(100vh - 62px)' }}>
            <Sidebar menuItems={menuItems} collapsed={false} onToggle={() => setMobileMenuOpen(false)} isMobile={true} />
          </div>
        )}

        {/* MAIN CONTENT AREA - Flex item, fills remaining space with scrolling */}
        <main style={{ flex: 1, overflowY: 'auto', overflowX: 'hidden', minHeight: 0, minWidth: 0 }} className="p-3 sm:p-4 md:p-6 w-full">
          {children}
        </main>
      </div>
    </div>
  );
}